import { render, staticRenderFns } from "./App.vue?vue&type=template&id=51da45d7"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=51da45d7&prod&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=51da45d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports